/** 先頭のみ大文字に変換 */
export default function capitalize(value: string | undefined | null): string {
  if (!value) {
    return "";
  }
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}
